export enum SeatmapErrorCode {
    NOT_LOGGED_IN = '500-CMN-001',
    UNAUTHORIZED = '401-SMP-002'
}
